import { Component, Input, OnInit } from "@angular/core";
import * as moment from "moment";

@Component({
  selector: "app-card-prescricoes-component",
  templateUrl: "./card-prescricoes-component.component.html",
  styleUrls: ["./card-prescricoes-component.component.scss"],
})
export class CardPrescricoesComponentComponent implements OnInit {
  @Input("data") prescricao;
  @Input("ultimo") ultimo;

  constructor() { }

  ngOnInit() { }

  abrirItem() {
    this.prescricao.selecionado = !this.prescricao.selecionado;
  }

  abrirMed(ev: Event, index: number, med: any) {
    ev.stopPropagation();
    this.prescricao.medicamentos[index].selecionado =
      !this.prescricao.medicamentos[index].selecionado;
    console.log(med);
  }

  dateLabel(date: string) {
    return `${moment(date, "DD/MM/YYYY hh:mm").format("L")}`;
  }

  verificarStatus(status) {
    const blackList = ["Negado/Cancelado", "Em estado de erro", "Em espera"];
    return !blackList.includes(status);
  }
}
